import styled from 'styled-components'

export const UserDetailsWrapper = styled.div`
  .row:not(:first-child) {
    margin-top: 20px;
  }

  .section-wrapper {
    margin: 30px 0;

    &.first {
      font-family: ${props => props.theme.fonts.robotoRegular};
      font-size: ${props => props.theme.fontSizes.clients.clientView};
      color: ${props => props.theme.colors.secondary};
      padding: 40px 40px 65px 40px;
    }

    .section-title {
      margin: 0 0 30px 0;
    }

    .section-label {
      margin: 0 0 7px 0;
    }
  }

  .profile-picture {
    max-width: 120px;
    display: block;
  }

  input {
    width: auto;
  }
`



// WEBPACK FOOTER //
// ./src/Components/UserManagement/UserDetailsWrapper/index.js